<template>
	<div class="whiteBG border radius chatbox right-chatBlock w-100">
		<complete-loading :pageloader_value="pageLoader" :type="'complete'"
			v-if="pageLoader && !type_ticket_detail"></complete-loading>
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
		<div v-if="ticketView != ''">
			<div class="ChatHead d-flex flex-wrap align-items-center justify-content-between p-3 mb-3">
				<div class="title">
					<h3 class="mb-0" v-if="parseInt(ticketView.ticket[0].title) !== 0">
						<p v-for="list in ticketReasonList[ticketView.ticket[0].reason].categories"
							v-if="list.id == ticketView.ticket[0].title">
							{{ list.title }}
						</p>
					</h3>
					<h3 class="mb-0" v-else>
						{{ ticketReasonList[ticketView.ticket[0].reason].title }}
					</h3>
					<p class="mb-0">
						{{ $t("ticketNumber") }}:
						<strong>{{ ticketView.ticket[0].ticketnumber }}</strong>
					</p>
					<small>{{ ticketView.ticket[0].created | moment("DD MMMM") }}</small>
				</div>
				<div class="ticketnumber_in d-flex">
					<button class="btn btn-success mr-2" v-if="ticketView.ticket[0].reason == '97'"
						@click="cancelwithdrawalreq(ticketView.ticket[0].ticketnumber, ticketView.ticket[0].id)">Cancel
						Withdrawal
						Request</button>
					<router-link :to="{ name: 'fxView.support', params: { tabName: 'openRequest' } }"
						class="d-flex grd_btn align-items-center">
						<feather type="chevron-left"></feather>
						{{ $t("backToTicket") }}
					</router-link>
				</div>
			</div>
			<div class="scrollbar mid_scroll_content ticket" v-chat-scroll>
				<div class="mesgs">
					<div class="loader" v-if="type_ticket_detail"></div>
					<div class="msg_history">
						<div class="outgoing_msg">
							<div class="sent_msg">
								<div class="fr-view">
									<span class="mb-0"
										v-html="formatString(ticketView.ticket[0].comment)"><span></span></span>
								</div>
								<span class="time_date">
									{{
										ticketView.ticket[0].created | moment("DD MMMM YYYY")
									}}</span>
							</div>
						</div>
					</div>
					<div class="msg_history" v-for="(ticketThread, index) in ticketView.threads">
						<div class="incoming_msg" v-if="parseInt(ticketThread.ticket_updatedby) == 1">
							<div class="incoming_msg_img">
								<img src="../../../../static/fxView/images/user-profile.svg" alt="sunil" />
							</div>
							<div class="received_msg">
								<div class="received_withd_msg">
									<!-- <froalaView
										v-model="ticketThread.message"
										v-if="ticketThread.message != ''"
									></froalaView> -->
									<div class="fr-view">
										<span v-html="formatString(ticketThread.message)"
											v-if="ticketThread.message"></span>
									</div>
									<div class="attached_msg d-flex align-items-center justify-content-between"
										v-for="ticketThreadDoc in ticketThread.docs">
										<p class="p-0">
											<span>
												<feather type="paperclip"></feather>
											</span>
											{{ ticketThreadDoc.document }}
										</p>
										<a :href="docsLink +
											'user&id=' +
											ticketView.ticket[0].user_id +
											'&doc=' +
											ticketThreadDoc.document
											" class="contract_link" target="_blank()" v-if="parseInt(ticketView.ticket[0].reason) == 91 ||
											parseInt(ticketView.ticket[0].reason) == 94 ||
											parseInt(ticketView.ticket[0].reason) == 92
											">
											<span>
												<feather type="eye"></feather>
											</span>
										</a>
										<a :href="docsLink +
											'ticket&id=' +
											ticketView.ticket[0].user_id +
											'&doc=' +
											ticketThreadDoc.document
											" class="contract_link" target="_blank()" v-else>
											<span>
												<feather type="eye"></feather>
											</span>
										</a>
									</div>
									<span class="time_date">
										{{ dateFunction(ticketThread.created) }}</span>
								</div>
							</div>
						</div>

						<div class="outgoing_msg" v-if="parseInt(ticketThread.ticket_updatedby) == 0">
							<div class="sent_msg">
								<!-- <froalaView
								v-model="ticketThread.message"
								v-if="ticketThread.message != ''"
								></froalaView> -->
								<div class="fr-view">
									<span v-html="formatString(ticketThread.message)" v-if="ticketThread.message"></span>
								</div>

								<div class="attached_msg d-flex align-items-center justify-content-between"
									v-for="ticketThreadDoc in ticketThread.docs">
									<p class="p-0">
										<span>
											<feather type="paperclip"></feather>
										</span>{{ ticketThreadDoc.document }}
									</p>
									<a :href="docsLink +
										'user&id=' +
										ticketView.ticket[0].user_id +
										'&doc=' +
										ticketThreadDoc.document
										" class="contract_link" target="_blank()" v-if="parseInt(ticketView.ticket[0].reason) == 91 ||
											parseInt(ticketView.ticket[0].reason) == 92 ||
											parseInt(ticketView.ticket[0].reason) == 94
											">
										<span>
											<feather type="eye"></feather>
										</span>
									</a>
									<a :href="docsLink +
										'ticket&id=' +
										ticketView.ticket[0].user_id +
										'&doc=' +
										ticketThreadDoc.document
										" class="contract_link" target="_blank()" v-else>
										<span>
											<feather type="eye"></feather>
										</span>
									</a>
								</div>
								<span class="time_date">
									{{ dateFunction(ticketThread.created) }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="type_msg" v-if="parseInt(ticketView.ticket[0].status) != 3">
				<form action="" method="post" enctype="multipart/form-data" id="TicketReplyForm"
					v-on:submit.prevent="submitNow()">
					<div class="input_msg_write d-flex justify-content-between align-items-center">
						<textarea class="write_msg" :placeholder="$t('TypeMsz')" v-model="text" name="message"></textarea>
						<div class="input_msg_write_btn d-flex align-items-center">
							<div class="upload-btn-wrapper d-flex align-items-center">
								<!--copy-->
								<div class="showOnclick gooeyMenu"
									v-if="parseInt(ticketView.ticket[0].reason) == 91 || parseInt(ticketView.ticket[0].reason) == 121">
									<div class="uploadShowMenu" :class="setUpFxaccount ? 'active' : ' '">
										<ul class="listAnimated setUpFxaccount">
											<li class="bt1" v-for="val in fileNames">
												<div class="sptIcon">
													<feather size="16px" type="upload"></feather>
												</div>
												<div class="upload-btn-wrapper" @click="docType = val; $refs.file.click()">
													<a class="btn" href="#" @click="docType = val">{{ val.value }}</a>
												</div>
											</li>
										</ul>
									</div>
								</div>
								<div class="btn d-flex align-items-center" @click="$refs.file.click()" v-else>
									<feather type="paperclip" class="mr-2 position-static"></feather>
								</div>
								<input type="file" name="document[]" id="docfile" style="display:none" ref="file"
									@change="onFileChange($event.target.name, $event.target.files)" />
								<span class="nameIco" v-if="document != ''">
									<feather type="image" class="imgIQ mr-2"></feather>
									<p>{{ document }}</p>
									<feather type="x" class="closeIQ" @click="clear_doc()"></feather>
								</span>
								<!--  <span class="alert alert-danger position-absolute erroMT" v-if="submittedThread && (errors.has('document[]') ||  errors.has('message'))">please select one field</span> -->
								<!--copy-->
								<div class="input_msg_write_btn d-flex align-items-center mt-0">
									<div class="uploadGooey setUpFxaccount" :class="setUpFxaccount ? 'active' : ' '"
										v-if="parseInt(ticketView.ticket[0].reason) == 91 || parseInt(ticketView.ticket[0].reason) == 121">
										<a @click="setUpFxaccount = !setUpFxaccount" href="#">
											<feather class="addIB" type="plus"></feather>
											<feather class="closeIB" type="x"></feather>
										</a>
									</div>

								</div>
							</div>
							<button class="msg_send_btn" ><feather type="send" ></feather> </button>
						</div>
						<!--ADd More static-->
						<!-- <div class="showDocument d-flex align-items-center flex-wrap" v-if="rest.length > 0">
							<div class="d-flex align-items-center flex-wrap">
								<div class="showDocument-group repeateUpload" v-for="(value, index) in rest">
									<div class="ftIco">
										<feather size="16px" type="file"></feather>
									</div>
									<p class="m-0">
										{{ value.name }}
										<feather type="x" class="closeIt" @click="remove(index)"></feather>
									</p>
									<span class="sizeSM">{{ value.size / 1000 }}kb</span>
								</div>
							</div>
						</div>
						<button class="msg_send_btn" type="submit" :class="text != '' || rest.length > 0 ? '' : 'disabled'">
							{{ $t("send") }}
						</button> -->
					</div>
				</form>
			</div>
		</div>
	</div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import moment from "moment";
export default {
	name: "View-TICKET",
	mixins: [fxViewMixins],
	data() {
		return {
			//============message and loader ===========
			response_msg: "",
			msg_type: "",
			pageLoader: false,
			type_ticket_detail: false,
			loaderFuncRun: "1",
			//update_id : '',
			//==========================================
			document: "",
			submitted: false,
			text: "",
			config: {
				placeholder: "Edit Me",
				key: "ERB2zH3C1A8A2B2A1qYFd1UQRFQIVb1MSMc2IWPNe1IFg1yD4C3D2D2C4C1G1H4B1C1==",
			},
			rest: [],

			setUpFxaccount: false,
			document: '',
			fileNames: [
				{ name: 'Passport', value: 'Passport', type: 'Proof_of_Identity' },
				{ name: 'Drivers_License_BACK', value: 'Drivers License Back', type: 'Proof_of_Identity' },
				{ name: 'Drivers_License_FRONT', value: 'Drivers License Front', type: 'Proof_of_Identity' },
				{ name: 'Government_Issued_Photo_ID_BACK', value: 'Government Issued Photo ID Back', type: 'Proof_of_Identity' },
				{ name: 'Government_Issued_Photo_ID_FRONT', value: 'Government Issued Photo ID Front', type: 'Proof_of_Identity' },
				{ name: 'Bank_Credit_Card_Statement', value: 'Bank Statement/Credit Card Statement', type: 'Proof_of_Residence' },
				{ name: 'Utility_Bill', value: 'Utility Bill', type: 'Proof_of_Residence' },
				{ name: 'Payroll_Statement', value: 'Payroll Statement', type: 'Proof_of_Residence' },
				{ name: 'Tax_Document', value: 'Tax Document', type: 'Proof_of_Residence' },
				{ name: 'Photo_Verification', value: 'Liveness/Selfie', type: 'Photo_Verification' }
			],
			invidual_file: {},
			docType: '',
			submittedThread: false,
		};
	},
	methods: {
		//cancel withdrawal request
		cancelwithdrawalreq(ticket, ticket_id) {
			let input_json = {
				'globalParams': {
					'ticket': ticket,
					'ticket_id': ticket_id
				},
				'localParams': { "parameter": this }
			}
			this._runCancelWithdrawalRequest(input_json)
		},
		formatString(str) {
			return str
				.replace(/&amp;/g, "&")
				.replace(/&quot;/g, '"')
				.replace(/&#39;/g, "'")
				.replace(/&lt;/g, "<")
				.replace(/&gt;/g, ">");
		},
		clear() {
			this.document = "";
			this.text = "";
			document.getElementById("file").value = "";
			this.rest = [];
			this.submitted = false;
		},
		dateFunction(getDate) {
			let last_seen_date = moment(getDate).fromNow();
			return last_seen_date;
		},
		// onFileChange(event) {
		//   this.rest.push({
		//     name: event.target.files[0].name,
		//     file: event.target.files[0],
		//     size: event.target.files[0].size,
		//   });
		// },
		onFileChange(fieldName, file) {
			this.document = file[0].name
			this.setUpFxaccount = false
			if (parseInt(this.ticketView.ticket[0].reason) == 91 || parseInt(this.ticketView.ticket[0].reason) == 121) {
				this.invidual_file['file'] = file[0];
				this.invidual_file['name'] = file[0].name;
			}
		},
		ticketDetail() {
			let input_json = {
				'globalParams': {
					'ticket_id': this.$route.query.id,
					'from_ib' : this.$route.query.getVerifiedStatus
				},
				'localParams': { "parameter": this }
			}
			this._runGetTicketDetail(input_json);
		},
		clear_doc() {
			this.document = ''
			document.getElementById('docfile').value = ''
		},
		remove(getindex) {
			document.getElementById("file").value = "";
			this.rest = this.rest.filter((value, index) => index != getindex);
		},
		submitNow(getData){
			const _that = this
			if(getData == 'internalCommentTicket'){
				_that.submittedInternalComment = true;
				_that.$validator.validate().then(valid => {
					if (valid) {
						let TicketReplyForm = document.getElementById('TicketReplyForm');
						let form_name = new FormData(TicketReplyForm);
						form_name.append("user_id", this.ticketView.ticket[0].user_id);
						form_name.append("internal_msg", 1);
						form_name.append("trans_id", _that.ticketView.ticket[0].ticketnumber);
						let input_json ={
							'globalParams' :{
								"form" : form_name
							},
							'localParams' :{ "parameter" : _that ,"module" : 'ticket-reply'}
						};
						_that._runTicketReply(input_json)
					}else{
						_that.handleValidationErrorAdvanced(_that.errors)
					}
				});
			}else{
				_that.submittedInternalComment = false;
				let TicketReplyForm = document.getElementById('TicketReplyForm');
				let form_name = new FormData(TicketReplyForm);
				//121 and 92 in ib 
				//
				if((parseInt(_that.ticketView.ticket[0].reason) == 91 || parseInt(_that.ticketView.ticket[0].reason) == 121) && (_that.document != '')){
					form_name = new FormData();
					form_name.append('document[]', _that.invidual_file.file, _that.docType.name+ '.'+ _that.invidual_file.name.split('.')[_that.invidual_file.name.split('.').length -1] );
					form_name.append('documenttype', _that.docType.type);
					form_name.append('message', _that.text);
					// form_name.append('ticket_id', _that.ticketView.ticket[0].id);
				}
				if(parseInt(_that.ticketView.ticket[0].reason) == 91 || parseInt(_that.ticketView.ticket[0].reason) == 94 || parseInt(_that.ticketView.ticket[0].reason) == 121){
					form_name.append("type", 'user');
				}
				form_name.append("user_id", this.ticketView.ticket[0].user_id);
				form_name.append("trans_id", _that.ticketView.ticket[0].ticketnumber);
				form_name.append("from_ib", parseInt(_that.ticketView.ticket[0].from_ib));
				form_name.append("ticket_id", parseInt(_that.ticketView.ticket[0].id));
				let input_json ={
					'globalParams' :{
						"form" : form_name
					},
					'localParams' : { "parameter" : _that ,"module" : 'ticket-reply'}
				};
				if(form_name.get('message') == '' && form_name.get('document[]').name == ''){
					_that.$notify({
						group: 'foo',
						type :'error',
						text: "please select field",
						duration: 10000,
						closeOnClick : true
					});
				}else{
					_that._runTicketReply(input_json)
				}
				
			}
		},
		// submitNow() {
		// 	const _that = this;
		// 	if (_that.text != "" || _that.rest.length > 0) {
		// 		let form_name = "";
		// 		var address_length = 0;
		// 		if (_that.rest.length > 0) {
		// 			form_name = new FormData();
		// 			_that.rest.forEach((value) => {
		// 				if (value.name != "") {
		// 					address_length += 1;
		// 					form_name.append("document[]", value.file);
		// 				}
		// 			});
		// 			form_name.append("message", _that.text);
		// 			if (
		// 				parseInt(_that.ticketView.ticket[0].reason) == 91 ||
		// 				parseInt(_that.ticketView.ticket[0].reason) == 92 ||
		// 				parseInt(_that.ticketView.ticket[0].reason) == 94
		// 			) {
		// 				form_name.append("type", "user");
		// 			}
		// 		} else {
		// 			let formRequest = document.getElementById("TicketReplyForm");
		// 			form_name = new FormData(formRequest);
		// 		}
		// 		form_name.append("ticket_id", _that.ticketView.ticket[0].id);

		// 		let input_json = {
		// 			globalParams: {
		// 				form: form_name,
		// 			},
		// 			localParams: {
		// 				parameter: _that,
		// 				module: "ticket-reply",
		// 				tick_id: this.ticketView.ticket[0].id,
		// 			},
		// 		};
		// 		_that._runTicketReply(input_json);
		// 	}
		// },
	},
	created() {
		this.ticketDetail();
	},
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/supports/view.vue